import { easepick } from '@easepick/core';
import { LockPlugin } from '@easepick/lock-plugin';

function showBookingPanel() {
	document.body.classList.add('booking-panel-open');
}
function hideBookingPanel() {
	document.body.classList.remove('booking-panel-open');
}

function initBookingForm() {
	// Open/close booking panel
	const bookingPanel = document.querySelector('.c-booking');
	const openBookingTriggers = document.querySelectorAll('.js-open-booking-panel');
	const closeBookingTriggers = document.querySelectorAll('.js-close-booking-panel');

	openBookingTriggers.forEach((el) =>
		el.addEventListener('click', (e) => {
			e.preventDefault();
			showBookingPanel();
		})
	);
	closeBookingTriggers.forEach((el) =>
		el.addEventListener('click', (e) => {
			e.preventDefault();
			hideBookingPanel();
		})
	);

	// Submit booking form
	const bookBtn = bookingPanel.querySelector('#booking-link');
	const inputs = bookingPanel.querySelectorAll('.js-book-input');
	const adultInput = bookingPanel.querySelector('#adults');
	const adultPlus = bookingPanel.querySelector('#adults-plus');
	const adultMinus = bookingPanel.querySelector('#adults-minus');
	const childrenInput = bookingPanel.querySelector('#children');
	const childrenPlus = bookingPanel.querySelector('#children-plus');
	const childrenMinus = bookingPanel.querySelector('#children-minus');

	bookBtn.addEventListener('click', (e) => {
		e.preventDefault();

		// Get params for all inputs
		const inputData = [];
		inputs.forEach((input) => {
			if (input.value.length !== 0 && input.value !== '0') {
				const inputParam = input.getAttribute('data-param');
				inputData.push(`&${inputParam}=${input.value}`);
			}
		});

		const baseUrl = bookBtn.getAttribute('href');
		const inputStr = inputData.join('');
		const analyticsStr = window.Cookiebot?.consent?.statistics ? '&_ga=2.44734244.1457332436.1578319889-211037964.1575556747#' : '';

		const url = baseUrl + inputStr + analyticsStr;
		window.open(url, '_blank');
	});

	// Adults click/change events
	adultMinus.addEventListener('click', (e) => minus(adultInput));
	adultPlus.addEventListener('click', (e) => plus(adultInput));
	adultInput.addEventListener('change', (e) => {
		this.attr('value', this.value);
		this.attr('data-value', this.value);
	});

	// Children click/change events
	childrenMinus.addEventListener('click', (e) => minus(childrenInput));
	childrenPlus.addEventListener('click', (e) => plus(childrenInput));
	childrenInput.addEventListener('change', (e) => {
		this.attr('value', this.value);
		this.attr('data-value', this.value);
	});

	// Promo code change event
	bookingPanel.querySelector('#promo-code').addEventListener('change', (e) => {
		this.attr('value', this.value);
		this.attr('data-value', this.value);
	});

	let availableDates = [];

	// Start date datepicker
	const today = new Date();
	let endDate;
	const startDate = new easepick.create({
		element: document.getElementById('booking-start-date'),
		css: [
			'https://cdn.jsdelivr.net/npm/@easepick/core@1.2.1/dist/index.css',
			'https://cdn.jsdelivr.net/npm/@easepick/lock-plugin@1.2.1/dist/index.css',
			'https://therebellodev.wpengine.com/wp-content/themes/the-rebello/assets/css/easepick.css',
		],
		lang: bookingPanel.getAttribute('data-locale'),
		date: today,
		format: 'DD MMM, YYYY',
		zIndex: 99,
		plugins: [LockPlugin],
		LockPlugin: {
			filter(date) {
				return date.isBefore(new Date());
			},
		},
		setup(picker) {
			picker.on('select', (e) => {
				const { date } = e.detail;

				const dateFormatted = formatDate(date);
				bookingPanel.querySelector('#booking-start-date-formatted').value = dateFormatted;

				// Force departure easepick to re-render
				const newEndDate =
					endDate.getDate() < date
						? new Date(date.getTime() + 86400000)
						: endDate.getDate();
				endDate.setDate(newEndDate);
				endDate.trigger('select', { date: newEndDate });
			});
		},
	});

	// End date datepicker
	const tomorrow = new Date().setDate(today.getDate() + 1);
	endDate = new easepick.create({
		element: document.getElementById('booking-end-date'),
		css: [
			'https://cdn.jsdelivr.net/npm/@easepick/core@1.2.1/dist/index.css',
			'https://cdn.jsdelivr.net/npm/@easepick/lock-plugin@1.2.1/dist/index.css',
			'https://therebellodev.wpengine.com/wp-content/themes/the-rebello/assets/css/easepick.css',
		],
		lang: bookingPanel.getAttribute('data-locale'),
		date: tomorrow,
		format: 'DD MMM, YYYY',
		zIndex: 99,
		plugins: [LockPlugin],
		LockPlugin: {
			filter(date) {
				return !date.isAfter(startDate.getDate());
			},
		},
		setup(picker) {
			picker.on('select', (e) => {
				const { date } = e.detail;

				const dateFormatted = formatDate(date);
				bookingPanel.querySelector('#booking-end-date-formatted').value = dateFormatted;
			});
		},
	});

	function formatDate(date) {
		const day = date.getDate() >= 10 ? date.getDate() : '0' + date.getDate();
		const month = date.getMonth() >= 9 ? date.getMonth() + 1 : '0' + (date.getMonth() + 1);
		const year = date.getFullYear();
		return `${month}/${day}/${year}`;
	}

	function minus(input) {
		let count = parseInt(input.value) - 1;
		count = count < 0 ? 0 : count;
		input.value = count;

		const changeEv = new Event('change');
		input.dispatchEvent(changeEv);

		input.setAttribute('value', count);
		input.setAttribute('data-value', count);

		return false;
	}

	function plus(input) {
		var count = parseInt(input.value) + 1;
		input.value = count;

		const changeEv = new Event('change');
		input.dispatchEvent(changeEv);

		input.setAttribute('value', count);
		input.setAttribute('data-value', count);

		return false;
	}
}

initBookingForm();
